import { render } from "./diabetes_investigations.vue?vue&type=template&id=1846dc7c&scoped=true"
import script from "./diabetes_investigations.vue?vue&type=script&lang=js"
export * from "./diabetes_investigations.vue?vue&type=script&lang=js"

import "./diabetes_investigations.vue?vue&type=style&index=0&id=1846dc7c&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1846dc7c"]])

export default __exports__